import React from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../LanguageContext';

const DeleteConfirmation = ({ onConfirm, onCancel, itemName, isDeleting }) => {
    const { t, isRtl } = useLanguage();
    return ReactDOM.createPortal(
        <div className="overlay-fade-in" style={{
            position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)'
        }} onClick={onCancel}>
            <div className="modal-fade-in" style={{ width: 400, background: '#fff', borderRadius: 12, padding: 32, textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }} onClick={e => e.stopPropagation()}>
                <div style={{ background: '#fff1f0', color: '#cf1322', width: 56, height: 56, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </div>
                <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1c1d' }}>
                    {isRtl ? 'تأكيد الحذف' : 'Delete Confirmation'}
                </h2>
                <p style={{ fontSize: 13, color: '#6d7175', margin: '0 0 24px' }}>
                    {isRtl ? 'هل أنت متأكد من حذف' : 'Are you sure you want to delete'} <strong>{itemName}</strong>?
                    <br />{isRtl ? 'لا يمكن التراجع عن هذا الإجراء.' : <><strong>cannot</strong> be undone.</>}
                </p>
                <div style={{ display: 'flex', gap: 12 }}>
                    <button disabled={isDeleting} onClick={onCancel} style={{ flex: 1, padding: '10px', borderRadius: 8, border: '1px solid #d2d2d2', background: '#fff', color: '#1a1c1d', fontWeight: 600, fontSize: 14, cursor: isDeleting ? 'not-allowed' : 'pointer', opacity: isDeleting ? 0.6 : 1 }}>
                        {t.cancel}
                    </button>
                    <button disabled={isDeleting} onClick={onConfirm} style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#d82c0d', color: '#fff', fontWeight: 600, fontSize: 14, cursor: isDeleting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {isDeleting ? <div className="dots-loading"><span></span><span></span><span></span></div> : t.delete}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default DeleteConfirmation;
